import { render, staticRenderFns } from "./tp.vue?vue&type=template&id=b735fc24&scoped=true&"
import script from "./tp.vue?vue&type=script&lang=js&"
export * from "./tp.vue?vue&type=script&lang=js&"
import style0 from "./tp.vue?vue&type=style&index=0&id=b735fc24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b735fc24",
  null
  
)

export default component.exports